import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ApplicationModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RvrsCreateStep2Component } from './rvrs-create-step2.component';
import { WizardModule } from '../../../../common/component/wizard/wizard.module';
import { ModalModule } from '../../../../common/component/modal/modal.module';
import { SpinnerModule } from '../../../../common/component/spinner/spinner.module';
import { AlertModule } from '../../../../common/component/alert/alert.module';
import { FormsModule } from '@angular/forms';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NglModule} from 'ng-lightning';
import { GridModule } from '@progress/kendo-angular-grid';

@NgModule({
  imports: [
    CommonModule
    ,WizardModule
    ,FormsModule
    ,UploadModule
    ,DateInputsModule
    ,DropDownsModule
    ,NglModule
    ,ModalModule
    ,SpinnerModule
    ,AlertModule
    ,ApplicationModule
    ,GridModule],
  declarations: [RvrsCreateStep2Component],
  exports: [RvrsCreateStep2Component],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RvrsCreateStep2Module { }
